var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form Fields/Checkbox input"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.859375,
    y: 1.33984,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "#7D8BA1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.859375,
    y: 1.33984,
    width: 19,
    height: 19,
    rx: 3.5,
    stroke: "#7D8BA1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.6184 6.83083C15.8527 7.06524 15.9844 7.38312 15.9844 7.71458C15.9844 8.04603 15.8527 8.36392 15.6184 8.59833L9.36839 14.8483C9.13398 15.0827 8.81609 15.2143 8.48464 15.2143C8.15318 15.2143 7.8353 15.0827 7.60089 14.8483L5.10089 12.3483C4.87319 12.1126 4.7472 11.7968 4.75005 11.4691C4.7529 11.1413 4.88436 10.8278 5.11612 10.5961C5.34788 10.3643 5.66139 10.2328 5.98914 10.23C6.31688 10.2271 6.63264 10.3531 6.86839 10.5808L8.48464 12.1971L13.8509 6.83083C14.0853 6.59649 14.4032 6.46484 14.7346 6.46484C15.0661 6.46484 15.384 6.59649 15.6184 6.83083Z",
    fill: "#C4CAD4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.4722ebe7600656372b3d4657c917942a.svg";
export { ForwardRef as ReactComponent };